import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
} from "@angular/common/http";
import { AddImageVM, BogieCountVM, BogieImageModel, BogieShimNameModel, InspectionBogieGroup } from "./bogie-shim-model";
import { Observable } from "rxjs";
import { catchError } from "rxjs/internal/operators/catchError";
import { Tuple } from "../../../entities";

@Injectable()
export class BogieShimService {
  constructor(private _http: HttpClient) {}

  private readonly API_BASE = "api/Inspection/";
  private readonly API_BASE_INTERP = "api/Interpretation/";

  getBogieShimName() {
    return this._http.get<BogieShimNameModel[]>(this.API_BASE + "GetAllBogies");
  }
  public getAWSImagePath(image: string): Observable<BogieImageModel> {
    return this._http.post<BogieImageModel>(this.API_BASE + "GetAWS_UploadImage", {Image: image}).pipe(catchError(this.handleError));
  }
  private handleError(error: HttpErrorResponse) {
    console.log(error);
    return Observable.throw(error.message || "Server error");
  }
  
  getBogieHistoryDetails(equipmentId:number, side:number): Observable<InspectionBogieGroup[]> {
    const options = {
      params: new HttpParams().set('EquipmentId', equipmentId.toString()).set('Side', side.toString())
    };
    return this._http.get<InspectionBogieGroup[]>(this.API_BASE + 'GetBogieShimInspectionHistory', options).pipe(catchError(this.handleError));
  }

  updateCount(count: BogieCountVM): Observable<any> {
    return this._http.post<any>('api/interpretation/UpdateBogieCount', count).pipe(catchError(this.handleError));
   }

  addBogieShimPhoto(photo: AddImageVM): Observable<Tuple> {
    return this._http.post<Tuple>('api/interpretation/AddBogieShimImage', photo).pipe(catchError(this.handleError));
  }

}
